module.exports = __webpack_public_path__ + "static/media/LogicWheel2_2_drag_3.aca77edd.png";